/**
 * @fileoverview SPANISH strings for `@puffin-core/form-security`.
 * @package @puffin-core/form-security
 *
 * UNREACHABLE-MODULE-BURNDOWN-001 Q-UMB-21 (2026-09-24). Register is **usted**, ecosystem-wide —
 * `Podrá volver a intentarlo`, never `Podrás`. Key set is intentionally identical to `en.js`.
 *
 * Authored by Claude (AI), NOT reviewed by a native speaker — every leaf is `machine` in `_meta.js`,
 * which is what puts this package in the ES review queue.
 */

export const FORM_SECURITY_STRINGS_ES = Object.freeze({
  'formSecurity.rateLimit.locked':
    'Demasiados intentos. Este formulario está bloqueado temporalmente.',
  'formSecurity.rateLimit.countdown': 'Podrá volver a intentarlo en {{time}}.',
  'formSecurity.rateLimit.remaining':
    'Intentos restantes antes de un bloqueo temporal: {{attempts}}.',
});

export default FORM_SECURITY_STRINGS_ES;
